enum STEPS {
    CONTRACT_MODEL = 1,
    OWNER_REGISTER,
    TENANT_REGISTER,
    CONTRACT_CREATION
}

export default STEPS;